import { frontendURL } from 'dashboard/helper/URLHelper.js';

import KanbanBoardPage from './pages/KanbanBoardPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const kanbanRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_index',
      meta,
      component: KanbanBoardPage,
    },
  ],
};

export default kanbanRoutes;
